import React from 'react'
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry'
import useReveal, { revealClass } from '../hooks/useReveal'
import RevealImage from './revealImage'

const Seccion_ImgSimple = ({id, title, images, imgAlt}) => {
  const [ref, visible] = useReveal()

  return (
    <div ref={ref} id={id} className={`flex flex-col h-full w-full gap-12 py-10 ${revealClass(visible)}`}>
        <h3>{title}</h3>
        <ResponsiveMasonry 
                columnsCountBreakPoints={{350: 1, 750: 2, 1280: 2}}
            >
                <Masonry gutter="20px">
                {images.map((image, index) => (
                  <RevealImage
                    key={index}
                    index={index}
                    src={image}
                    alt={"Maria_Estevez_"+title+"_"+index}
                  />
                ))}
                </Masonry>
            </ResponsiveMasonry>
    </div>
  )
}

export default Seccion_ImgSimple